// Incomplete-period marking for month-bucketed analytics categories (SHER-853).
//
// Every finances endpoint buckets by calendar month and then calls generateMonthsInRange,
// so the range always ends on the month that is still running. Its bar is a partial
// figure by construction -- on the 1st of the month, near zero -- and on the Total
// Billing line that read as revenue collapsing rather than as a month in progress.

const MONTH_CATEGORY = /^(\d{4})-(\d{2})$/;

const currentMonthKey = (now: Date): string =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;

/** True when the category is a `YYYY-MM` bucket for the month that has not closed yet. */
export const isIncompleteMonth = (category: string, now: Date = new Date()): boolean =>
  typeof category === 'string' && MONTH_CATEGORY.test(category) && category === currentMonthKey(now);

/**
 * Appends `suffix` to the still-running month. Categories that are not months -- most
 * analytics charts are keyed by department, and this component is shared with them -- are
 * returned untouched, as are null labels, which total-patients really does emit
 * (SHER-846).
 */
export const markIncompleteMonths = (
  categories: string[],
  suffix: string,
  now: Date = new Date(),
): string[] => {
  if (!Array.isArray(categories)) {
    return categories;
  }
  return categories.map((category) =>
    isIncompleteMonth(category, now) ? `${category} ${suffix}` : category,
  );
};
